import Link from 'next/link';
import ChevronRight from '../../../../packages/components/src/svg/ChevronRight';
import { Subheading, Paragraph } from '../../../../packages/components/src/typography';
import { SmallCardFieldsFragment } from '../../@types/generated';
import { colors } from 'components/src/foundation';
import Button from 'components/src/button';
import Download from './Icons/Download';
import { ImageWithFocalPoint } from './ImageWithFocalPoint';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document, BLOCKS } from '@contentful/rich-text-types';
import clsx from 'clsx';
import { downloadBlob } from '@/utils/utils';

type Props = {
  data: SmallCardFieldsFragment;
};

const RichTextContainer = ({ data }: { data: Document }) => {
  return documentToReactComponents(data, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => {
        return <Paragraph classes="text-black-100 empty:h-[18px]">{children}</Paragraph>;
      },
    },
  });
};

const Card = ({ data }: Props) => {
  return (
    data.title &&
    data.image && (
      <div
        tabIndex={0}
        className={`${data.style === 'flat' ? 'bg-transparent' : 'rounded-28 bg-white-100 shadow-card'} ${clsx({
          'hover:cursor-pointer': data.uri,
        })}`}
      >
        <div className="relative h-160 rounded-28">
          <ImageWithFocalPoint
            image={data.image}
            sectionId={data.image.id}
            className="rounded-t-28"
            contain={data.style === 'flat'}
            sizes={{
              // Small card image is never larger than 500px
              default: '500px',
            }}
          />
        </div>
        <div className="p-16">
          <div className="mb-16 flex items-center justify-between">
            <Subheading bold classes="text-black-50">
              {data.title}
            </Subheading>
            {data.uri && (
              <div className="h-20 w-24">
                <ChevronRight color={colors.monochrome.inverse[2]} strokeWidth={1.5} />
              </div>
            )}
          </div>
          <div className="whitespace-break-spaces">
            <RichTextContainer data={data.descriptionMarkdown?.json} />
          </div>
        </div>
        {data.buttonAction && (
          <>
            {data.image?.image?.url && <a id="" className="hidden" download={data.image?.image?.url} />}
            <Button
              label={data.buttonAction === 'downloadImage' ? 'Sækja' : ''}
              onClick={() => {
                if (data.image?.image?.url) {
                  fetch(data.image.image.url)
                    .then((res) => res.blob())
                    .then((blob) => {
                      downloadBlob(blob, data.image?.image?.fileName);
                    });
                }
              }}
              variant="surface"
              autoWidth={false}
              icon={<Download />}
            />
          </>
        )}
      </div>
    )
  );
};

const CardContainer = ({ data }: Props) => {
  if (data.uri) {
    return (
      <Link className="grid" key={data.title} href={data?.uri ? data.uri : ''}>
        <Card data={data} />
      </Link>
    );
  }
  return (
    <div className="grid" key={data.title}>
      <Card data={data} />
    </div>
  );
};

const SmallCard = ({ data }: Props) => {
  return <CardContainer data={data} />;
};
export default SmallCard;
